"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const mobx_react_1 = require("mobx-react");
require("./index.scss");
const react_helmet_1 = __importDefault(require("react-helmet"));
const TabsWrapperComponent_1 = __importDefault(require("@Components/TabsWrapperComponent"));
const MaintenanceMobileSubLinks_1 = __importDefault(require("@Components/MaintenanceMobileSubLinks"));
const RightsholderMaintenanceContactTab_1 = __importDefault(require("@Scenes/RightsholderScene/RightsholderMaintenance/RightsholderMaintenanceContactTab"));
const RightsholderMaintenanceBankingTab_1 = __importDefault(require("@Scenes/RightsholderScene/RightsholderMaintenance/RightsholderMaintenanceBankingTab"));
const permissions_1 = require("@Const/permissions");
const contexts_1 = require("@App/contexts");
const tabs_constants_1 = require("@Const/tabs-constants");
const analytics_utils_1 = require("@App/common/utils/analytics-utils");
const RightsholderMaintenance = () => {
    const { uiStore, rightsholderUserStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const getTabs = () => {
        const myMaintenanceTabs = [];
        if (rightsholderUserStore.doesRHUserHavePermissionOrIsInternal(permissions_1.PERMISSIONS.RIGHTSHOLDER_PERMISSIONS.manage_contact_and_address)) {
            myMaintenanceTabs.push({
                tabName: tabs_constants_1.MAINTENANCE_TABS.mailingAndContact.name,
                tabDescription: tabs_constants_1.MAINTENANCE_TABS.mailingAndContact.description,
                tabComponent: react_1.default.createElement(RightsholderMaintenanceContactTab_1.default, { key: tabs_constants_1.MAINTENANCE_TABS.mailingAndContact.name }),
            });
        }
        if (rightsholderUserStore.doesRHUserHavePermission(permissions_1.PERMISSIONS.RIGHTSHOLDER_PERMISSIONS.manage_banking_and_tax)) {
            myMaintenanceTabs.push({
                tabName: tabs_constants_1.MAINTENANCE_TABS.bankingAndTax.name,
                tabDescription: tabs_constants_1.MAINTENANCE_TABS.bankingAndTax.description,
                tabComponent: react_1.default.createElement(RightsholderMaintenanceBankingTab_1.default, { key: tabs_constants_1.MAINTENANCE_TABS.bankingAndTax.name }),
            });
        }
        return myMaintenanceTabs;
    };
    (0, react_1.useEffect)(() => {
        (0, analytics_utils_1.analyticsSendPage)('rightsholder_maintenance');
    }, []);
    const myMaintenanceTabs = getTabs();
    if (!myMaintenanceTabs[0]) {
        return null;
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_helmet_1.default, { title: 'Maintenance' }),
        react_1.default.createElement("div", { className: "rightsholder-maintenance-wrapper" },
            react_1.default.createElement("div", { className: 'global-container' },
                uiStore.isMobile && react_1.default.createElement(MaintenanceMobileSubLinks_1.default, null),
                react_1.default.createElement(TabsWrapperComponent_1.default, { tabs: myMaintenanceTabs, defaultTab: myMaintenanceTabs[0], showContentHeaderPerTab: true })))));
};
exports.default = (0, mobx_react_1.observer)(RightsholderMaintenance);
